
import { Injectable, Inject } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SnackService } from '../shared-services/snack.service';
import { BackendService } from '../core/backend.service';
import { Banner } from './banner.model';

@Injectable()
export class BannerResolver implements Resolve<Banner> {
  constructor(
    protected router: Router,
    protected snackService: SnackService,
    protected backendService: BackendService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      const id = route.params.id || 'agregar';

      if (id === 'agregar') {
        return this.backendService.new(Banner);
      }
      return await this.backendService.get(Banner, Banner.path + id).toPromise();
    } catch (error) {
      this.router.navigate(['/banner']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/banner/banner.resolver.ts